import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 12h2a2 2 0 1 0 0 -4h-2v8m4 0l-3 -4","key":"svg-0"}]]

/**
 * IconLetterRSmall
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItbGV0dGVyLXItc21hbGwiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTEwIDEyaDJhMiAyIDAgMSAwIDAgLTRoLTJ2OG00IDBsLTMgLTQiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/letter-r-small
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconLetterRSmall = createReactComponent('outline', 'letter-r-small', 'LetterRSmall', __iconNode);

export default IconLetterRSmall;